<template>
  <div ref="mapContainer" style="width: 100%; height: 500px"></div>
  <v-dialog
    v-model="showDialogDetail"
    width="auto"
    :close-on-content-click="closeOnContentClick"
  >
    <v-card class="googleMapsCard" max-width="400">
      <v-card-title>{{ showPopupData.LocationName }}</v-card-title>
      <v-card-text>
        <div>{{ showPopupData.StreetHouseNumber }}</div>
        <div>{{ showPopupData.ZipcodeCity }}</div>
        <div>{{ showPopupData.Country }}</div>
        <div>{{ showPopupData.Email }}</div>
        <div>{{ showPopupData.Telephone }}</div>
        <div v-if="showPopupData.GoogleUrl.length>1">
          <a target="_blank" :href="showPopupData.GoogleUrl">Maps</a>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<style scoped>
/* background color of select options, otherwise it will be transperant */
.googleMapsCard {
  background-color: white !important;
}
</style>
<script setup>
import { onMounted, ref } from "vue";
import { useSiteSettingsStore } from "../../store/siteSettings";

const mapContainer = ref(null);
const { GOOGLE_MAPS_API_KEY } = useRuntimeConfig().public;
let showDialogDetail = ref(false);
let showPopupData = ref([]);
const siteSettings = useSiteSettingsStore();
let closeOnContentClick = true; // Prevent console warning in develop mode closeOnContentClick expect boolen got string

function loadGoogleMapsAPI(callback) {
  const script = document.createElement("script");
  script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&libraries=places`;
  script.async = true;
  script.defer = true;
  script.onload = callback;
  document.head.appendChild(script);
}

onMounted(() => {
  if (!window.google) {
    loadGoogleMapsAPI(() => {
      initializeMap();
    });
  } else {
    initializeMap();
  }
});

function handleMarkerClick(address) {
  showPopupData = address;
  showDialogDetail.value = true;
}
function formatCoordinates(stringIn){
  // replace , bij .
  return parseFloat(stringIn.replace(/,/g, '.'))
}
function initializeMap() {
  const map = new google.maps.Map(mapContainer.value, {
    center: calculateCenter(), // Centre of the adresses
    zoom: 1, // Zoomniveau is adjusted below?
  });
// make a  LatLngBounds object
   var bounds = new google.maps.LatLngBounds();
  siteSettings.StokvisLocation.forEach((address) => {
    const marker = new google.maps.Marker({
      position: {
        lat: formatCoordinates(address.Latitude.replace(/,/g, '.')),
        lng: formatCoordinates(address.Longitude.replace(/,/g, '.')),
      },
      map,
      title: address.LocationName,
    });
// Voeg de marker positie toe aan de bounds
    bounds.extend({
      lat: formatCoordinates(address.Latitude),
      lng: formatCoordinates(address.Longitude)
    });
    // add click listener to show adres detail in popup
    marker.addListener("click", () => { 
      handleMarkerClick(address);
    });
  });

  // adjust zoomlevel so that every marker is visible on the map
    map.fitBounds(bounds);
}
// calculate center of al adresses
function calculateCenter() {
  if (siteSettings.StokvisLocation.length == 0) {
    return { lat: 52.2397612, lng: 4.4894213 }; //stokvis voorhout
  } else if (siteSettings.StokvisLocation.length == 1) {
    return {
      lat: formatCoordinates(siteSettings.StokvisLocation[0].Latitude),
      lng: formatCoordinates(siteSettings.StokvisLocation[0].Longitude),
    };
  }

  // Sort addresses by lat
  const sortedByLat = [...siteSettings.StokvisLocation].sort(
    (a, b) => a.Latitude - b.Latitude
  );
  // Sort addresses by lng
  const sortedByLng = [...siteSettings.StokvisLocation].sort(
    (a, b) => a.Longitude - b.Longitude
  );

  return {
    lat:
      (formatCoordinates(sortedByLat[sortedByLat.length - 1].Latitude) +
      formatCoordinates(sortedByLat[0].Latitude)) /
      2,
    lng:
      (formatCoordinates(sortedByLng[sortedByLng.length - 1].Longitude) +
      formatCoordinates(sortedByLng[0].Longitude)) /
      2,
  };
}
</script>

